export interface PositionViewModel {
	id: number;
	key: string;
	lat: number;
	lng: number;
	date: string;
	tooltip: string;
	displayFields: object;
	displayFieldNames: string[];
	displayFieldValues: string[];
	address: string;
	markerType: MapMarkerType;
	links: Link[];
}

export interface Link {
	label: string;
	value: string;
	href: string;
}

export enum MapMarkerType {
	Pin,
	Flag,
}

export interface MapSettings {
	mapTypes: string[];
	canShowPositions: boolean;
	showPositions: boolean;
	canShowLeads: boolean;
	showLeads: boolean;
	canShowSales: boolean;
	showSales: boolean;
	canShowRetailLocations: boolean;
	showRetailLocations: boolean;
	defaultMaxPositions: number;
	maxPositions: number;
}
